import { render, staticRenderFns } from "./MiniGame.vue?vue&type=template&id=8f7562fe&"
import script from "./MiniGame.vue?vue&type=script&lang=js&"
export * from "./MiniGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports